/* eslint-disable import/prefer-default-export */

import padronToString from 'utils/padronesToString';
import addressToString from 'utils/address';
import { padronesEnum } from 'views/Tramites/GPM/enums';
import { store } from 'store';

export const PREDIOS_MAPPING = {
  clave_del_padron: 'clave',
  clave_principal_del_padron: 'clave_catastral_municipal',
  clave_secundaria_del_padron: 'clave_sectorial',
  nombres_completos_del_padron: (padron) => padronToString(padron, padronesEnum.PREDIO).split(' - ')[1],
  direccion_codigo_postal: (padron) => padron?.direccion_index?.codigo_postal?.d_codigo
    || padron?.direccion?.codigo_postal?.d_codigo,
  direccion_del_padron: (padron) => addressToString(padron?.direccion_index || padron?.direccion),
  correo_electronico_del_padron: 'padron.contribuyente.email',
  telefono_del_padron: 'padron.contribuyente.numero_de_celular',
  estatus_del_padron: (padron) => {
    const { estadosGlobales } = store.getState().catalogs;
    return estadosGlobales.find((e) => e.id === padron?.estados_globales)?.descripcion;
  },
  observaciones_del_padron: 'observaciones_del_padron',
  direccion_de_notificacion_del_padron: (padron) => {
    const direccion = padron?.direccion_notificacion_index || padron?.direccion_notificacion;
    return addressToString(direccion);
  },
  lada_celular_del_padron: 'padron.contribuyente.lada_de_celular',
  celular_del_padron: 'padron.contribuyente.numero_de_celular',
};

export const CONTRIBUYENTE_EJECUCIONES_MAPPING = {
  clave_del_contribuyente: 'clave',
  lada_celular_del_contribuyente: 'lada_de_celular',
  celular_del_contribuyente: 'numero_de_celular',
  lada_telefono_del_contribuyente: 'lada_de_telefono',
  telefono_del_contribuyente: 'numero_de_telefono',
  tipo_de_persona: (contribuyente) => {
    const { tiposDePersonas } = store.getState().catalogs;
    return tiposDePersonas.find((t) => t.id === contribuyente?.tipo_de_persona)?.descripcion;
  },
  nombre_completo_del_contribuyente: (contribuyente) => padronToString(contribuyente, padronesEnum.CONTRIBUYENTE).split(' - ')[1],
  rfc_del_contribuyente: 'rfc',
  id_del_contribuyente: 'id',
  curp_del_contribuyente: 'CURP',
  nombre_comercial_del_contribuyente: 'nombre_comercial',
  nombre_del_contribuyente: 'nombre',
  apellido_paterno_del_contribuyente: 'apellido_paterno',
  apellido_materno_del_contribuyente: 'apellido_materno',
  fecha_de_nacimiento_constitucion_de_contribuyente: 'fecha_de_constitucion',
  lugar_de_nacimiento_constitucion_de_contribuyente: 'lugar_de_constitucion',
  direccion_de_notificacion_del_contribuyente: (contribuyente) => addressToString(contribuyente
    ?.direccion_notificacion_index || contribuyente?.direcciones_de_notificacion),
  direccion_del_contribuyente: (contribuyente) => addressToString(contribuyente
    ?.direccion_index || contribuyente?.direcciones),
  correo_electronico_del_contribuyente: 'email',
  observaciones_del_contribuyente: 'observaciones_del_contribuyente',
  estatus_del_contribuyente: (contribuyente) => {
    const { estadosGlobales } = store.getState().catalogs;
    return estadosGlobales.find((e) => e.id === contribuyente?.estados_globales)?.descripcion;
  },
};

export const MAPPERS = {
  [padronesEnum.PREDIO]: PREDIOS_MAPPING,
  [padronesEnum.CONTRIBUYENTE]: CONTRIBUYENTE_EJECUCIONES_MAPPING,
};

export function getValueByPath(obj, path) {
  if (Array.isArray(path)) {
    // Buscar el primer valor que encuentre en el array de paths
    const foundValue = path.find((p) => {
      const value = getValueByPath(obj, p);
      return value !== undefined && value !== null && value !== '';
    });
    return foundValue ? getValueByPath(obj, foundValue) : undefined;
  }

  // Si path es una función, ejecutarla directamente con el objeto
  if (typeof path === 'function') {
    return path(obj);
  }

  // Si path es un string, dividirlo por puntos y navegar por el objeto
  if (typeof path === 'string') {
    return path.split('.').reduce((acc, key) => {
      if (acc && typeof acc === 'object' && key in acc) {
        return acc[key];
      }
      return undefined;
    }, obj);
  }

  return undefined;
}

export function normalizeObject(rawObject, mapping) {
  const result = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const [targetKey, sourcePath] of Object.entries(mapping)) {
    const value = getValueByPath(rawObject, sourcePath);
    result[targetKey] = value ?? '';
  }
  return result;
}
